import { render, staticRenderFns } from "./CardWithLogo.vue?vue&type=template&id=10c2298e&scoped=true&"
import script from "./CardWithLogo.vue?vue&type=script&lang=js&"
export * from "./CardWithLogo.vue?vue&type=script&lang=js&"
import style0 from "./CardWithLogo.vue?vue&type=style&index=0&id=10c2298e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2298e",
  null
  
)

export default component.exports